<osc-utils-spinner class="osc-app-spinner" [spinnerId]="spinnerService.mainSpinnerId"></osc-utils-spinner>
<evc-platform [inputAppIdentification]="appIdentification" inputForcedTheme="light" [inputSettingsMenu]="settingsMenu"
  [changeOrganization]="onOrganizationChanging" (logout)="onLogout()">
  <main>
    @if(ready()) {
    <router-outlet></router-outlet>
    }
  </main>
</evc-platform>